import _ from 'lodash';
import store from '@/store';

const isFeatureSupported = (feature) => {
  const deviceObj = store.getters.device;
  const os = _.get(deviceObj, 'os.name', '').toLowerCase();
  const browser = _.get(deviceObj, 'client.name', '').toLowerCase();

  switch (feature) {
    case 'gpsCheckin':
      return "geolocation" in navigator;

    case 'pwa':
      // works on chrome and edge (win desktop/android) edge (android) and safari (ios/ipados > v13.4.1) only
      return (/ios|ipados/.test(os) && /safari/.test(browser)) ||
              (os === 'android' && /chrome|edge/.test(browser)) ||
              (os === 'windows' && /chrome|edge/.test(browser)) ||
              (os === 'mac' && /chrome/.test(browser));

    case 'cameraStream':
      return 'getUserMedia' in navigator || ('mediaDevices' in navigator && navigator.mediaDevices.getUserMedia);
  }
}

export default isFeatureSupported;
